import { NgModule, Injector, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScTimerComponent } from './sc-timer.component';
import { CustomElementService } from '../../../../formbird-sc-shared/src/lib/services/custom-element.service';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { default as pjson } from '../../../../../package.json';
import {ComponentSetupModule} from '../../../../formbird-sc-shared/src/lib/component-setup.module';

@NgModule({
  declarations: [ScTimerComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    ComponentSetupModule
  ]
})
export class ScTimerModule {
  constructor(
    private injector: Injector,
    private customElementService: CustomElementService
  ) {
    customElementService.convertToCustomElement(ScTimerComponent, 'sc-timer', this.injector, pjson.version);

  }
}
